/**
 * quoteRequestPolling — helper PUR (zéro import api/supabase/window), testable
 * en environnement Node (parité `apiError.ts` / `extractedFieldEditorHelpers.ts`).
 *
 * 9.T.5.v3.7 post-smoke : le worker email-outbox (timer staging ~2 min) bascule
 * les recipients `pending → sent` de façon ASYNCHRONE, APRÈS l'invalidation
 * faite au moment du Send. Sans re-fetch, l'UI reste bloquée sur « En attente »
 * jusqu'à un refresh manuel. `useQuoteRequest` poll le détail tant que ce
 * prédicat retourne `true`.
 */

/** Forme minimale d'un recipient nécessaire à la décision de polling. */
export type RecipientPollShape = {
  status: string;
  recipient_email: string | null;
};

/**
 * Faut-il continuer à poller le détail d'une QR ?
 * `true` tant qu'au moins un recipient est « délivrable-en-attente » (`pending`
 * AVEC email — le worker le basculera `sent`). `false` sinon : tous terminaux,
 * OU seuls des `pending` SANS email subsistent (zero-deliverable non traité par
 * le worker → garde-fou anti-polling-infini).
 */
export function shouldPollRecipientStatuses(
  recipients: ReadonlyArray<RecipientPollShape>,
): boolean {
  return recipients.some((r) => r.status === "pending" && !!r.recipient_email);
}
